import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const ViewFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.sessions.filters.view);
  const selectedOption = useSelector((state) => state.sessions.selectedFilters.view);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOption}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateViewFilter(data))}
    />
  );
};

export default ViewFilter;
